import {
  collection,
  onSnapshot,
  FirestoreError,
  query,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../types";
import { Session } from "./types";
import { transformMetadata, processTimestampFields } from "../utils";

export type SessionOnSnapshotCollectionService<T> = (
  opts: ListServiceOpts,
  callback: (docs: Array<T>) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotCollection: SessionOnSnapshotCollectionService<
  EntityGet<Session>
> = (opts: ListServiceOpts, callback, onError = () => {}) => {
  const collectionRef = collection(db, `/session`);
  const { disableCache } = opts;
  const q = opts.listQueryFn
    ? opts.listQueryFn(collectionRef)
    : query(collectionRef);
  return onSnapshot(
    q,
    { includeMetadataChanges: disableCache },
    (querySnap) => {
      const { metadata } = querySnap;
      const { fromCache } = metadata;
      if (disableCache && fromCache) return;
      callback(
        querySnap.docs.map(
          (doc) =>
            processTimestampFields(
              transformMetadata(
                {
                  ...doc.data(),
                  id: doc.id,
                } as EntityServerGet<Session>,
                doc.metadata
              )
            ) as EntityGet<Session>
        )
      );
    },
    onError
  );
};

export default onSnapshotCollection;
